import React from 'react';
import './index.less';

const Logo = () => {
    const handleJumpToHome = () => {
        window.location.href = window.location.origin;
    };
    return (
        <div className="p-header__logo" onClick={handleJumpToHome}>
            <img
                title=""
                src="https://prepc.meitudata.com/designer-poster-editor/static/media/logo-light.19dab13a.svg"
                width="116"
                height="31"
                style={{
                    pointerEvents: 'none',
                }}
            />
        </div>
    );
};

export default React.memo(Logo);
